import _ from 'lodash';
import can from 'can/view/view';
import Component from 'can/component/component';
import template from './modal-photo-gallery.stache';
import List from 'scripts/models/base/list';
import appContext from 'scripts/app-context';
import Cloudinary from 'scripts/utils/cloudinary';

import DomEventsManager from 'scripts/dom-events-manager';

const THUMBS_SLIDE_SPACE = 7;

const Model = can.Map.extend({
    component: null,
    element: null,
    imageTitle: null,
    imageIndex: null,
    galleryTop: null,
    galleryTopContainer: null,
    galleryThumbs: null,
    galleryThumbsContainer: null,
    galleryThumbsWrapper: null,
    slidesCount: 0,
    visible: false,
    define: {
        active: {
            type: 'htmlbool',
            value: false
        },
        photos: {
            Type: List,
            Value: List
        },
        galleryTitle: {
            type: 'string',
            value: ''
        },
        galleryUrl: {
            type: 'string',
            value: ''
        },
        activeSlideIndex: {
            type: 'number',
            value: 0
        },
        activeSlide: {
            type: '*'
        },
        shareImage: {
            get: function () {
                const activeSlide = this.attr('activeSlide');

                if (activeSlide && activeSlide.image) {
                    return Cloudinary.getImagePath(activeSlide.image.identifier);
                }

                return '';
            }
        },
        shareUrl: {
            get: function () {
                const baseUrl = this.attr('galleryUrl');
                const activeSlideIndex = this.attr('activeSlideIndex');

                return baseUrl.split('#')[0] + (activeSlideIndex > 0 ? can.route.url({slide: activeSlideIndex}) : '');
            }
        }
    },

    hide () {
        if (!this.active) {
            return;
        }

        if (this.galleryTop) {
            this.galleryTop.destroy(true);
        }
        if (this.galleryThumbs) {
            this.galleryThumbs.destroy(true);
        }

        can.remove(this.component);

        this.attr('component', null);
        this.attr('active', false);

        this.dispatch('modalClosed', []);
        appContext.model.dispatch('page-scroll-toggle', [false]);
    },

    initTopSwiper () {
        this.galleryTop = new Swiper(this.galleryTopContainer, {
            spaceBetween: 0,
            preventClicks: false,
            zoom: true,
            keyboardControl: true,
            onTransitionEnd: (slider) => this.onTransitionEnd(slider),
            nextButton: this.galleryTopContainer.find('.swiper-button-next'),
            prevButton: this.galleryTopContainer.find('.swiper-button-prev')
        });
    },

    initThumbsSwiper () {
        this.galleryThumbs = new Swiper(this.galleryThumbsContainer, {
            spaceBetween: THUMBS_SLIDE_SPACE,
            slidesPerView: 'auto',
            slidesPerGroup: 2,
            nextButton: this.galleryThumbsWrapper.find('.swiper-button-next'),
            prevButton: this.galleryThumbsWrapper.find('.swiper-button-prev'),
            touchRatio: 0.2,
            freeMode: true,
            slideToClickedSlide: false
        });

        this.updateGalleryThumbsSlides(this.galleryTop.activeIndex);
    },

    onTransitionEnd (slider) {
        let activeIndex = slider.activeIndex;

        if (this.galleryThumbs) {
            this.galleryThumbs.slideTo(activeIndex);
        }
        this.updateGalleryThumbsSlides(activeIndex);
        this.setActiveSlide(activeIndex);
    },

    updateGalleryThumbsSlides (activeIndex) {
        let index = parseInt(activeIndex);

        index = isNaN(index) ? 0 : index;

        this.galleryThumbsContainer.find('.expanded-slide').removeClass('expanded-slide');
        this.galleryThumbsContainer.find('.swiper-slide').eq(index).addClass('expanded-slide');
    },

    setActiveSlide (slide) {
        let index = 0;

        if (!_.isNaN(slide) && slide < this.slidesCount) {
            index = slide;
        }

        let imageData = this.photos[index];

        if (!imageData) {
            return;
        }

        let imageCaption = imageData.caption || '';

        if (imageCaption.length > 260) {
            imageCaption = imageCaption.substring(0, 260) + '...'
        }

        this.imageTitle.text(imageCaption);
        this.imageIndex.text(`${index + 1} of ${this.slidesCount}`);
        this.attr('activeSlideIndex', index);
        this.attr('activeSlide', this.photos[index]);

        if (this.slidesCount === 1) {
            this.imageIndex.addClass('single-slide');
        }

        if (this.galleryTop) {
            this.galleryTop.slideTo(index);
        }
        if (this.galleryThumbs) {
            this.galleryThumbs.slideTo(index);
        }
    },

    thumbnailsToggle (stateOverride) {
        this.showThumbnails = stateOverride !== undefined ? stateOverride : !this.showThumbnails;
        this.element.toggleClass('thumbnails-shown', this.showThumbnails);
        this.showThumbnails ? this.galleryThumbsWrapper.slideDown({
            duration: 150,
            easing: 'linear'
        }) : this.galleryThumbsWrapper.slideUp({duration: 150, easing: 'linear'});
        this.updateThumbsSlider();
        this.galleryThumbsWrapper.find('image-cloudinary').each((i, component) => {
            can.$(component).viewModel().recalculateSize(component);
            can.$(component).viewModel().show();
        });
    },

    getCurrentSlideIndex () {
        let slide = this.galleryTop ? this.galleryTop.activeIndex : 0;

        if (isNaN(slide)) {
            slide = 0;
        }

        return slide;
    },

    updateSliders () {
        setTimeout(function () {
            this.updateSlider();
            this.updateThumbsSlider();
        }.bind(this), 250);
    },

    updateSlider () {
        const slide = this.getCurrentSlideIndex();

        if (this.galleryTop) {
            this.galleryTop.detachEvents();
            this.galleryTop.destroy();
            this.galleryTop = null;
        }
        this.initTopSwiper();
        this.setActiveSlide(slide);
    },

    updateThumbsSlider () {
        const slide = this.getCurrentSlideIndex();

        if (this.galleryThumbs) {
            this.galleryThumbs.detachEvents();
            this.galleryThumbs.destroy();
            this.galleryThumbs = null;
        }

        if (this.checkThumbsFitness()) {
            this.galleryThumbsWrapper.addClass('thumbs-fit');
        }
        else {
            this.galleryThumbsWrapper.removeClass('thumbs-fit');
            this.initThumbsSwiper();
        }

        this.updateGalleryThumbsSlides(slide);

        if (this.galleryThumbs) {
            this.galleryThumbs.slideTo(slide);
        }

    },

    checkThumbsFitness () {
        const thumbsWidth = this.galleryThumbsContainer.find('.swiper-slide').toArray().reduce((prev, el) =>
            prev + this.element.width() + (prev > 0 ? THUMBS_SLIDE_SPACE : 0), 0);

        return thumbsWidth <= this.galleryThumbsContainer.width();
    },

    thumbSlideClick (el) {
        let index = parseInt(el.dataset['slideId']);

        this.setActiveSlide(index);
    },

    toggleSlideInfo () {
        const $el = this.viewModel.attr('element');
        const imageInfoContainer = this.viewModel.attr('imageInfoContainer');

        $el.toggleClass('is-hidden-description');
        $el.hasClass('is-hidden-description') ? imageInfoContainer.fadeOut({
            duration: 150,
            easing: 'linear'
        }) : imageInfoContainer.fadeIn({duration: 150, easing: 'linear'});
    },

    config: {
        get: function () {
            return {
                imgPath: _.get(window, 'globalSettings.imgPath', '')
            };
        }
    }
});

Component.extend({
    viewModel: Model,
    template: template,
    leakScope: false,
    tag: 'modal-photo-gallery',
    events: {
        inserted: function ($component) {
            DomEventsManager.subscribe(this);

            const $el = $component.find('.c-modal-photo-gallery');

            this.viewModel.attr('component', $component);
            this.viewModel.attr('element', $el);
            this.viewModel.attr('galleryTopContainer', $el.find('.swiper-container.gallery-top'));
            this.viewModel.attr('imageInfoContainer', $el.find('.s-image-info'));
            this.viewModel.attr('imageTitle', $el.find('.s-slide-title'));
            this.viewModel.attr('imageIndex', $el.find('.s-slide-index'));
            this.viewModel.attr('galleryThumbsWrapper', $el.find('.gallery-thumbs-wrapper'));
            this.viewModel.attr('galleryThumbsContainer', $el.find('.swiper-container.gallery-thumbs'));
            this.viewModel.attr('slidesCount', this.viewModel.photos.length);

            this.viewModel.galleryTopContainer.find('.swiper-slide').each((i, el) =>
                can.$('.s-slide-desc-item--position', el).html(`${i + 1} of ${this.viewModel.slidesCount}`));

            if (this.viewModel.slidesCount > 1) {
                this.viewModel.initTopSwiper();
            } else {
                $el.addClass('single-slide');

                if (!this.viewModel.attr('photos.0.image.caption')) {
                    $el.addClass('no-description');
                }
            }

            this.viewModel.attr('active', true);

            appContext.model.dispatch('page-scroll-toggle', [true]);

            this.viewModel.updateSliders();

            setTimeout(() => {
                this.viewModel.galleryTopContainer.find('image-cloudinary').each(function (i, component) {
                    can.$(component).viewModel().recalculateSize(component);
                    can.$(component).viewModel().show();
                });
            }, 250);
        },

        removed: function () {
            DomEventsManager.unsubscribe(this);
        },

        onWindowResize () {
            if (this.viewModel.active) {
                this.viewModel.updateSliders();
            }
        },

        '{document} keyup' (element, event) {
            if (event.keyCode === 27 && this.viewModel.attr('active')) {
                this.viewModel.hide();
            }
        }
    }
});